export default function cookieNotice() {
    // Variables
    const cookieNotice = document.getElementById('cookie-notice');
    const cookieButton = document.getElementById('cookie-button');

    if (cookieNotice) {
        // Check existance of cookie
        if(document.cookie.indexOf('cookie=notice') == -1) {
            cookieNotice.style.display = 'block';
        } else {
            cookieNotice.parentNode.removeChild(cookieNotice);
        }
    }

    if (cookieButton) {
        // Dismiss notice
        cookieButton.addEventListener('click', function () {
            cookieNotice.parentNode.removeChild(cookieNotice);
            let date = new Date();
            date.setTime(date.getTime()+(30*24*60*60*1000));
            document.cookie = "cookie=notice; expires=" + date.toGMTString() + "; path=/";
        });
    }

}


// WEBPACK FOOTER //
// ./components/cookie-notice.js